import { configureStore } from "@reduxjs/toolkit"

/* Reducers */
import operators from "./operators"
import admin from "./admin"
import loading from "./loading"
import language from "./language"
import timezone from "./timezone"
import catalog from "./catalog"


/* THE STORE HOLDS STATE ONLY — THE BOOT REQUESTS BELONG TO components/MainLoading.js
 * Firing them here made importing this module perform network calls, and the panel loaded them twice */
const store = configureStore({
    reducer: {
        operators,
        admin,
        loading,
        language,
        timezone,
        catalog,
    },
})

export { store }
